import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SubscriptionsManager } from '../util/subscriptions-manager';
import { LotService } from '../inventory/service/lot.service';
import { JhiEventManager } from '../core-utils';

@Component({
    selector: 'jhi-column-filter-lot-attributes',
    template: `
		<form #f='ngForm'>
			<section class="filter-wrapper">
				<div class="keyword-wrapper">
					<input type="text" class="form-control" [formControl]="queryField" id="keyword" placeholder="{{ lotAttributesPlaceHolder | translate }}" autofocus/>
				</div>
				<ul class="filter-select">
					<li *ngFor="let result of results" class="filter-select-list" (click)="addAttribute(result)">
						<div>
							<img class="variable-select-icon" alt="Property" src="/ibpworkbench/controller/static/images/property.svg">
							<span> {{result.property.name}} </span>
						</div>
						<div>
							<img class="variable-select-icon" alt="Variable" src="/ibpworkbench/controller/static/images/variable.png">
							<span *ngIf="result.alias"  class="label-info"> {{result.alias}} ({{result.name}})</span>
							<span *ngIf="!result.alias" class="label-info"> {{result.name}}</span>
						</div>
					</li>
				</ul>
			</section>
			<div *ngIf="this.filter.attributes.length === 0"><span>{{ 'column-filter.attributes.label' | translate }}</span></div>
			<br/>
			<div *ngFor="let attribute of filter.attributes">
				<div class="form-group">
					<label *ngIf="attribute.alias" for="{{attribute.name}}">{{attribute.name}} ({{attribute.alias}})</label>
					<label *ngIf="!attribute.alias" for="{{attribute.name}}">{{attribute.name}}</label>
					<div class="input-group">
						<input type="text" class="form-control" [(ngModel)]="attribute.value" name="{{attribute.name}}">
                        <button class="btn btn-outline-info fa fa-minus" (click)="deleteAttribute(attribute)"></button>
					</div>
				</div>
			</div>
			<br/>
			<div class="footer text-center"><br>
				<button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
				<button class="btn btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
			</div>
		</form>
    `
})
export class ColumnFilterLotAttributesComponent implements OnInit, OnDestroy {

    queryField: FormControl = new FormControl();
    results: any[] = [];
    subscriptionManager = new SubscriptionsManager();

    @Input() filter: any;

    @Output() onAdd = new EventEmitter();
    @Output() onDelete = new EventEmitter();
    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    lotAttributesPlaceHolder: string;

    constructor(private lotService: LotService,
                private eventManager: JhiEventManager) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.subscriptionManager.add = this.queryField.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap((query) => this.lotService.searchAttributes(query))
        ).subscribe((result) => {
            if (result.status === 400) {
                return;
            } else {
                this.results = result.body;
            }
        });

        this.lotAttributesPlaceHolder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.attributes.placeholder';
    }

    addAttribute(attribute) {
        // Reset query field value
        this.queryField.setValue('');
        // Do not add attribute if it's already in the list
        if (!this.filter.attributes.some((e) => e.id === attribute.id)) {
            this.filter.attributes.push({ ...attribute, value: '' });
        }
        this.onAdd.emit(attribute);
    }

    deleteAttribute(attribute) {
        this.filter.attributes = this.filter.attributes.filter((e) => e.id !== attribute.id);
        this.onDelete.emit(attribute);
    }

    apply(form) {
        if (!form.valid) {
            return;
        }

        this.eventManager.broadcast({ name: 'lotAttributeFiltersChanged', content: this.filter.attributes });
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
